// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-my-page h1{text-align:center;margin-top:0}", "",{"version":3,"sources":["webpack://./src/components/MobileMyPage/style.scss"],"names":[],"mappings":"AACI,mBACI,iBAAA,CACA,YAAA","sourcesContent":[".mobile-my-page {\n    h1 {\n        text-align: center;\n        margin-top: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
